import { render, staticRenderFns } from "./categorycolumn.vue?vue&type=template&id=155325c0&scoped=true"
import script from "./categorycolumn.vue?vue&type=script&lang=js"
export * from "./categorycolumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155325c0",
  null
  
)

export default component.exports